import { ALL_USERS, SET_USER_PAGE, SET_USER_PAGE_SIZE, SET_USER_TOTAL } from "../types"

const initialState = {
    users: [],
    page: 1,
    pageSize: 10,
    totalItems: 0
}

const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case ALL_USERS: {
            return {
                ...state,
                users: action.data
            }
        }
        case SET_USER_PAGE: {
            return {
                ...state,
                page: action.payload
            }
        }
        case SET_USER_PAGE_SIZE: {
            return {
                ...state,
                pageSize: action.payload
            }
        }
        case SET_USER_TOTAL: {
            return {
                ...state,
                totalItems: action.payload
            }
        }
        default: {
            return state
        }
    }
}

export default usersReducer